<template>
  <div class="container">
    <p>{{ paso }} de {{ config.cantPasos }}</p>
  </div>
</template>

<script>
export default {
  name: "StepCounter",
  props: ["paso"]
};
</script>

<style scoped>
div.container {
  text-align: left;
}

div.container,
p {
  margin-bottom: 0px;
}

p {
  font-family: BentonSansBBVA-MediumItalic;
  font-size: 15px;
  font-weight: 500;
  font-stretch: normal;
  font-style: italic;
  line-height: normal;
  letter-spacing: normal;
  color: #666666;
}
</style>
